import { render, staticRenderFns } from "./index.vue?vue&type=template&id=025211b3"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IndexLandingCarousel: require('/opt/build/repo/components/Index/LandingCarousel.vue').default,IndexWhatMakesPtjUnique: require('/opt/build/repo/components/Index/WhatMakesPtjUnique.vue').default,IndexFeaturedProducts: require('/opt/build/repo/components/Index/FeaturedProducts.vue').default,IndexOurProcess: require('/opt/build/repo/components/Index/OurProcess.vue').default,IndexGiftCertificate: require('/opt/build/repo/components/Index/GiftCertificate.vue').default,IndexAbout: require('/opt/build/repo/components/Index/About.vue').default,IndexLeaveAReview: require('/opt/build/repo/components/Index/LeaveAReview.vue').default})
